import { render, staticRenderFns } from "./control-line-height.vue?vue&type=template&id=18c183ec&"
import script from "./control-line-height.vue?vue&type=script&lang=js&"
export * from "./control-line-height.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports